import React, { useEffect, useState } from "react"
import { useStaticQuery, graphql } from "gatsby"
import { Box, Text } from '@sqymagma/elements'
import TableLoader from "../Loaders/TableLoader"

const ModCCAATable = ({ fecha }) => {
  const tableData = useStaticQuery(graphql`
    query {
      allCovidDailyCcaa {
        nodes {
          fecha

          regiones {
            data {
              casosRecuperados
              casosFallecidos
              casosConfirmadosDiario
              casosConfirmados
            }
            nombreLugar
          }
        }
      }
    }
  `)

  const [ tableDataFilterByDate, setTable ] = useState(null)
    useEffect(() => (
      setTable(tableData.allCovidDailyCcaa.nodes.find(el => el.fecha === fecha))
    ), [tableData.allCovidDailyCcaa.nodes, fecha])

  return (
    tableDataFilterByDate
    ? (
      <Box width={1} my="m">
      
      <div className="table-segment" >
        <Text as="h3" textStyle="l-semi" mb="xs">Desglose por comunidad autónoma</Text>
        <table id="tablafechaTimeline-2020-03-31" className="visualization-table">
          <thead className="visualization-table-head">
            <tr>
              <td colSpan="5">Total España</td>
            </tr>
          </thead>
          <tbody className="visualization-table-body">
            <Text as="tr" textStyle="table-row">
              <th colSpan="1" className="cell-comunidad">
                Comunidad
              </th>
              <th colSpan="1">Recuperados</th>
              <th colSpan="1">Fallecidos</th>
              <th colSpan="1">Nuevos</th>
              <th colSpan="1">Totales</th>
            </Text>

            {tableDataFilterByDate.regiones.map((region,idx) => {
              const {
                casosRecuperados, 
                casosFallecidos, 
                casosConfirmadosDiario, 
                casosConfirmados 
              } = region.data

              const {nombreLugar} = region;
              
              return (
                region && (
                  <Text as="tr" key={idx} textStyle="table-row">
                    {nombreLugar !== null && <td className="cell-comunidad">{nombreLugar}</td>}
                    {casosRecuperados  !== null && <td className="cell-recuperados">{casosRecuperados >= 0 ? casosRecuperados : "n/a"}</td>}
                    {casosFallecidos  !== null && <td className="cell-fallecidos">{casosFallecidos}</td>}
                    {casosConfirmadosDiario  !== null &&<td className="cell-confirmados">{casosConfirmadosDiario}</td>}
                    {casosConfirmados  !== null && <td className="cell-total">{casosConfirmados}</td>}
                  </Text>
                )
              )
            }) }
          </tbody>
        </table>
      </div>
    </Box>
    )
    :  <Box width={1}>
          <TableLoader/>
        </Box>
  )
}
export default ModCCAATable
